
import { Component, Vue, Prop } from 'vue-property-decorator';
import commonService from '@/services/common-services';
import { APP_CONFIG } from '@/config/app-config';
import authService from '@/services/auth-services';
import { DATA } from '@/config/data';

@Component
export default class DeliveryInfo extends Vue {
    @Prop({default: null})
    private customer: any;
    private listAddress: any[] = [];

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
    }

    get chinaStore() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private async getChinaStore() {
        const result = await commonService.getChinaStore();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CHINASTORE', result.data.data);
        }
    }

    private async getAddressBook() {
        const result = await authService.addressInfo(this.userInfo.userId);
        if (result && result.status === 200) {
            this.listAddress = result.data.data;
            const defaultAddr = this.listAddress.find((p) => p.IsDefault);
            this.customer.AddressBookID = defaultAddr ? defaultAddr.ID : 0;
            this.onChangeAddress();
        }
    }

    private async onChangeAddress() {
        const defaultAddr = this.listAddress.find((p) => p.ID === this.customer.AddressBookID);
        this.customer.PhoneNumber = defaultAddr.Phone;
        this.customer.Address = defaultAddr.Address;
        this.customer.FirstName = defaultAddr.Receiver;
        this.customer.LastName = '';
    }

    private async created() {
        if (!this.warehouse) {
            await this.getWarehouse();
        }
        if (!this.chinaStore) {
            await this.getChinaStore();
        }
        if (this.listAddress.length === 0) {
            await this.getAddressBook();
        }
    }
}
